import { ReactNode } from 'react'
import { Box, Image, useColorModeValue } from '@chakra-ui/react'
import ReactMarkdown from 'react-markdown'

import { getStrapiMedia } from '@/utils/getStrapiMedia'
import { ICardWithIcon } from '@/types/cardWithIcon.interface'

export function CardWithIcon({ title, description, icon }: ICardWithIcon) {
  const cardBg = useColorModeValue('white', 'black')

  const renderIcon = (icon: string | ReactNode, altText: string) => {
    // a url to icon is passed to CardWithIcon
    if (typeof icon === 'string' && icon.length) {
      return (
        <Image src={getStrapiMedia(icon)} alt={altText} w={'full'} h={'full'} />
      )
    }

    // JSX component is passed to CardWithIcon
    // feel free to update this return statement. Only if statement above is used for now
    return icon
  }

  return (
    <Box shadow={'md'} pt={9} px={8} pb={8} borderRadius={'2xl'} bg={cardBg}>
      {icon && (
        <Box w={10} h={10} borderRadius={'lg'} mb={4}>
          {renderIcon(icon, title)}
        </Box>
      )}
      <Box fontSize={'xl'} fontWeight={700} mb={4}>
        <ReactMarkdown>{title}</ReactMarkdown>
      </Box>
      <Box fontSize={'md'} fontWeight={400}>
        <ReactMarkdown>{description}</ReactMarkdown>
      </Box>
    </Box>
  )
}
